import { getClientNameFromSearchModality } from '@/components/search/v1/utils/helpers';
import { formatSearchModality } from '@/components/search/v1/utils/searchValidations';
import { getClientNameFromSearchModality as getClientNameFromSearchModalityV2 } from '@/components/search/v2/utils/helpers';
import { formatSearchModality as formatSearchModalityV2 } from '@/components/search/v2/utils/searchValidations';
import useClientState from '@/state/useClientState';

const useSearchUtils = () => {
  const isVersionOne = useClientState((state) => state.version === 1);

  return {
    formatSearchModality: isVersionOne ? formatSearchModality : formatSearchModalityV2,
    getClientNameFromSearchModality: isVersionOne ? getClientNameFromSearchModality : getClientNameFromSearchModalityV2,
  };
};
export default useSearchUtils;
